import WalletTable from "components/Tables/Wallet/WalletTable";
import React from "react";

const Wallet = () => {
  return (
    <div>
      <WalletTable />
    </div>
  );
};

export default Wallet;
